import Axios from "axios";
import React, { useEffect, useState } from "react";
import ItemLista from "../../components/sidebar_administrativo/ItemLista";
import SidebarAdministrativo from "../../components/sidebar_administrativo/Sidebar_Administrativo";
import { useHistory } from "react-router-dom";
import { formatDate } from "../../utils/date";

const TelecEncerrada = (props) => {
  Axios.defaults.withCredentials = true;

  const [lista, setLista] = useState([]);
  const [nome, setNome] = useState("");
  let history = useHistory();

  useEffect(() => {
    Axios.defaults.withCredentials = false;

    Axios.get(`${process.env.REACT_APP_API_BASE_URL}/login`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }).then((response) => {
      if (response.data.loggedIn === true) {
        setNome(response.data.user[0].nome);
        Axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/telecFechadas`
        ).then((response) => {
          if (response.data.message) {
            alert(response.data.message);
          }
          console.log(response);
          setLista(response.data);
        });
      }
    });
  }, []);

  const abrirTeleconsulta = (id) => {
    history.push({
      pathname: "/adm/detalhes",
      state: { detail: id },
    });
  };

  const chatTeleconsultoria = (id) => {
    history.push({
      pathname: "/adm/chatTeleconsultoria",
      state: { room: id, nome: nome },
    });
  };

  return (
    <>
      <SidebarAdministrativo>
        <div class="main__container">
          <table class="content-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>SOLICITANTE</th>
                <th>DATA</th>
                <th>CHAT</th>
                <th>FARMACÊUTICO</th>
                <th>ÁREA INTERESSE</th>
                <th>STATUS</th>
                <th>AÇÃO</th>
              </tr>
            </thead>
            <tbody align="justify">
              {lista.map((item) => (
                <tr>
                  <th>{item.id}</th>
                  <th>{item.nome}</th>
                  <th>{formatDate(item.data_hora)}</th>
                  <th>
                    {" "}
                    <a
                      style={{ cursor: "pointer" }}
                      id={item.id}
                      onClick={(e) => chatTeleconsultoria(e.target.id)}
                    >
                      Abrir
                    </a>
                  </th>
                  <th>{item.nome_farmaceutico}</th>
                  <th>{item.area_interesse}</th>
                  <th>{item.status}</th>
                  <th>
                    <th>
                      <a
                        id={item.id}
                        style={{ cursor: "pointer" }}
                        onClick={(e) => abrirTeleconsulta(e.target.id)}
                      >
                        Acessar
                      </a>
                    </th>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SidebarAdministrativo>
    </>
  );
};

export default TelecEncerrada;
